export const getTodayDetails = (): {
  year: number;
  month: number;
  date: string;
} => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // Month is 0-indexed, so we add 1
  const date = String(today.getDate()).padStart(2, '0'); // Zero-padded date

  return {
    year,
    month,
    date: `${year}-${String(month).padStart(2, '0')}-${date}`,
  };
};
